import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Alert,
  useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { confirmUser } from "../../api/authAPI";
import { useSearchParams } from "react-router-dom";

export default function ConfirmSignup() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const courseId = searchParams.get("courseId");

  // optional: prefill email if passed from signup
  const prefilledEmail = location.state?.username || "";

  const [email, setEmail] = useState(prefilledEmail);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !code) {
      setError("Email and verification code are required");
      return;
    }

    try {
      setLoading(true);
      const res = await confirmUser(email, code);
      console.log(res, "res kya aaya")

      if (res.data.success) {
        setSuccess(true);

        // redirect after short delay
        setTimeout(() => {
          navigate(`/login?courseId=${courseId || ""}`)
        }, 2000);
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        "Invalid or expired verification code"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {/* Logo */}
      <Box textAlign="center" mb={3}>
        <Box
          component="img"
          src="/csepathshala.png"
          alt="Topperhub"
          sx={{
            height: 56,
            mb: 1,
            filter:
              theme.palette.mode === "dark"
                ? "brightness(1.1)"
                : "none",
          }}
        />
      </Box>

      <Typography
        variant="h4"
        fontWeight={400}
        textAlign="center"
        mb={3}
      >
        Confirm Your Account
      </Typography>

      <Typography
        variant="body1"
        textAlign="center"
        mb={4}
        color={theme.palette.text.secondary}
      >
        Enter the verification code sent to your email
      </Typography>

      <form onSubmit={handleConfirm}>
        <Stack spacing={3}>
          <TextField
            label="Email"
            type="text"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
          />

          <TextField
            label="Verification Code"
            fullWidth
            value={code}
            onChange={(e) => setCode(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{
              borderRadius: "12px",
              paddingY: 1.2,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
              textTransform: "none",
              fontWeight: 500,
              fontSize: "16px",
            }}
          >
            {loading ? "Verifying..." : "Verify Account"}
          </Button>

          {error && (
            <Alert severity="error" sx={{ borderRadius: "10px" }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ borderRadius: "10px" }}>
              Registered successfully! Redirecting to login...
            </Alert>
          )}
        </Stack>
      </form>
    </Box>
  );
}
